import { render, staticRenderFns } from "./reviewResult.vue?vue&type=template&id=5f5d32b2&lang=html&"
import script from "./reviewResult.vue?vue&type=script&lang=ts&"
export * from "./reviewResult.vue?vue&type=script&lang=ts&"
import style0 from "./reviewResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports